export enum ParentComponent {
  Timesheet = 'timesheet',
  MonthlyReport = 'monthly'
}
